import { useEffect, useState } from "react";
import { getServicesStatus, TServicesStatus } from "../../../../services/backoffice/backoffice-service";
import { useAuthContext } from "../../../../contexts/auth-context";
import { TProcessStates } from "../../../../lib/types/general";
import { Spinner } from "../../../common/spinner";

export const StatusInfo = () => {
    const [servicesStatus, setServicesStatus] = useState<TServicesStatus>();
    const [status, setStatus] = useState<TProcessStates>("idle");

    const { getUserTokenId } = useAuthContext();
    const refreshStatus = async () => {
        setStatus("working");
        const userTokenId = await getUserTokenId();
        const response = await getServicesStatus(userTokenId);

        setServicesStatus(response.data);
        setStatus("done");
    };

    useEffect(() => {
        refreshStatus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="mb-4 p-3 border rounded shadow-sm bg-light rounded-3">
            <div className="row">
                <div className="col text-end">
                    <button onClick={refreshStatus} className="btn btn-primary">
                        <i className="fa-solid fa-refresh me-2"></i>
                        Refresh
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <strong>Cache ToGO</strong>
                </div>
                <div className="col-md-10">
                    {status === "working" && <Spinner spinnerColor="gray" />}

                    {status !== "working" &&
                        (servicesStatus?.data.cacheToGo.active ? (
                            <span>
                                <i className="fa-solid fa-circle text-success"></i> Active
                            </span>
                        ) : (
                            <span>
                                <i className="fa-solid fa-circle text-danger"></i> Inactive ({servicesStatus?.data.cacheToGo.errorMessage})
                            </span>
                        ))}
                </div>
            </div>
        </div>
    );
};
